import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { SEPARATOR__horizontal } from '../_base/separators/SEPARATOR__horizontal';
import { ReservationAseetsTypesListItem } from './ReservationAssetsTypesListItem';

interface Props {
  set_current_reservation_asset: (value: EReservationAssetType) => void;
  current_reservation_asset: EReservationAssetType;
}

export enum EReservationAssetType {
  BUNDLE = 'bundle',
  VAE = 'vae',
  TEXT_ENCODER = 'text_encoder',
  UNET = 'unet',
  CONTROLNET = 'controlnet',
  LORA = 'lora',
}

export function ReservationAseetsTypesList({ set_current_reservation_asset, current_reservation_asset }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  /*
   * EVENTS
   */

  function on_value_change_internal(value: string) {
    set_current_reservation_asset(value as EReservationAssetType);
  }

  /*
   * EFFECTS
   */

  /*
   * RENDERS
   */

  function render_items() {
    const items = Object.values(EReservationAssetType);

    return items.map(item => {
      return (
        <div className="w-full">
          <ReservationAseetsTypesListItem key={item} on_value_change={on_value_change_internal} value={item} selected_value={current_reservation_asset} />
          {item === EReservationAssetType.BUNDLE && <SEPARATOR__horizontal />}
        </div>
      );
    });
  }

  /*
   * HTML
   */

  return (
    <div className={`w-full flex flex-col`}>
      <div className="h-[40px] bg-bar px-2 text-page-foreground flex items-center justify-start">Assets:</div>
      <div className={`flex flex-col w-full bg-component overflow-auto pt-1  px-2  `}>{render_items()}</div>
    </div>
  );
}
